export default "__VITE_ASSET__6a4c7576__"